import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of, take, tap } from 'rxjs';
import { WINDOW } from '@bo-client/core/provider/window.provider';
import { AuthenticationService } from '@bo-client/core';
import { AuthorizationService } from '@bo-client/core/authorization/authorization.service';

@Injectable()
export class UserLoggedInGuard {
  constructor(
    @Inject(WINDOW) private window: Window,
    private router: Router,
    private authenticationService: AuthenticationService,
    private authorizationService: AuthorizationService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authenticationService.isLoggedIn) {
      this.authorizationService.selectRouteLogin$
        .pipe(
          take(1),
          tap((route) => {
            console.log('route canActivate', route);
            this.navigateToRoute(route);
          })
        )
        .subscribe();
    }
    return true;
  }

  private navigateToRoute(route: string) {
    const redirectUrl = sessionStorage.getItem('redirectUrl');
    if (redirectUrl) {
      sessionStorage.removeItem('redirectUrl');
      return of(this.router.navigateByUrl(redirectUrl, { replaceUrl: true }));
    } else {
      return this.router.navigate([route], {
        replaceUrl: true
      });
    }
  }
}
